export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/evaluate/pennant/query`,
          data
        });
      },

      save(data) {
          return http.json({
              url: '/evaluate/pennant/save',
              data
          })
      },
      getInfo(data) {
          return http.json({
              url: `/evaluate/pennant/get?id=${data.id}`
          })
      },
      /**
       * 删除版本
       * @param data
       * @return {*}
       */
      delete(data) {
          return http.json({
              url: `/evaluate/pennant/delete?id=${data[0].id}`,
              data
          })
      },
      list(){
          return http.json({
              url: `/evaluate/pennant/list`,
          })
      },
      handleIsTop(data){
          return http.json({
            url: `/evaluate/pennant/update`,
            data
        })
      }
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/pennant.js